import styled from '@emotion/styled'

export const Condition = styled.div`
  border-left: #cbcbcb 1px solid;
  color: #818080;
  font-feature-settings:
    'liga' off,
    'clig' off;
  font-family: Roboto;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 143%; /* 15.73px */
  letter-spacing: 0.133px;
  padding: 0 0.75rem;
  &:first-child {
    border-left: 0;
    padding-left: 0;
  }
`
